import classNames from 'classnames';
import React from 'react';

import {LocalizedHtml} from '@udemy/i18n';

import styles from './terms.module.less';

export const Terms = () => {
    return (
        <p className={classNames('ud-text-sm', styles['terms'])}>
            <LocalizedHtml
                html={gettext(
                    'By signing up, you agree to our <a class="terms">terms</a> and <a class="privacy-policy">privacy policy</a>. You agree that we can contact you about Udemy and use data from third parties to personalize your experience.',
                )}
                interpolate={{
                    terms: (
                        // TODO: Fix this link for a11y
                        /* eslint-disable react/jsx-no-target-blank */
                        // eslint-disable-next-line jsx-a11y/anchor-has-content
                        <a href="/terms/ub/" target="_blank" />
                    ),
                    // TODO: Fix this link for a11y
                    // eslint-disable-next-line jsx-a11y/anchor-has-content
                    'privacy-policy': <a href="/terms/ub-privacy/" target="_blank" />,
                }}
            />
        </p>
    );
};
